import { Input, Modal, Button, Upload, Divider, Segmented, Card } from 'antd'
import styled from 'styled-components'
import { AudioOutlined, UploadOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { useState } from 'react'


const Label = styled.div`
  width: 10em;
  flex-shrink: 0;
`

const StyledInput = styled(Input)`
  width: 24em;
`

const StyledDiv = styled.div`
  /* width: 24em; */
  overflow: hidden;
`


export function NewProjectDialog() {

  const [fileList, setFileList] = useState([
    {
      uid: '-1',
      name: 'Победа над сложностями судьбы День 3 Красноярск Сетябрь 2023.mp3',
      status: 'done',
      url: 'http://www.baidu.com/xxx.png',
    },
  ]);


  const handleChange = (info) => {
    let newFileList = [...info.fileList];

    // 1. Limit the number of uploaded files
    // Only to show two recent uploaded files, and old ones will be replaced by the new
    newFileList = newFileList.slice(-2);

    // 2. Read from response and show file link
    newFileList = newFileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });
    setFileList(newFileList);
  };


  const props = {
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    onChange: handleChange,
    multiple: true,
  };

  const [value, setValue] = useState('audio');


  return (
    <>
      <div className="_fv _fgap1" style={{ borderTop: '1px solid #e8e8e8', paddingTop: '2em' }}>

        <div className="_f _fm">
          <Label className="_f">Название проекта:</Label>
          <StyledInput
            placeholder="Название лекции"
          />
        </div>


        <Card title={<div className="_f100 _fcc" bodyColor="#ccc">
          <Segmented
            value={value}
            onChange={setValue}
            options={[
              {
                label: <div className="_f">
                  Аудио
                </div>,
                value: 'audio',
                icon: <AudioOutlined />,
              },
              {
                label: <div className="_f">
                  Видео
                </div>,
                value: 'video',
                icon: <VideoCameraOutlined />,
              },
            ]}
          />
        </div>} bordered={false}>

          {value === 'audio' && <div className="_fv">
            <Label className="_f">Исходное аудио:</Label>

            <StyledDiv>
              <Upload {...props} fileList={fileList} >
                <Button type="primary" size="small" icon={<UploadOutlined />}>Upload</Button>
              </Upload>
            </StyledDiv>
          </div>}

          {value === 'video' && <div className="_fv">
            <Label className="_f">Исходное видео:</Label>

            <StyledDiv>
              <Upload {...props} fileList={fileList} >
                <Button type="primary" size="small" icon={<UploadOutlined />}>Upload</Button>
              </Upload>
            </StyledDiv>
          </div>}


        </Card>






      </div>
    </>
  )
}